var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 center"},[_c('a',{staticClass:"mediumgrey termsconditions no-hover",staticStyle:{"font-size":"15px"},attrs:{"href":"#/webshop/terms-and-conditions","target":"_blank","rel":"noopener noreferrer"}},[_c('i',{staticClass:"el-icon-document-checked"}),_vm._v(" Find betingelser her")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4418a159","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/portal/webshop/footer.vue
// module id = 1366
// module chunks = 4